<template>
  <router-view v-slot="{ Component }">
    <keep-alive include="Home">
      <component :is="Component" />
    </keep-alive>
  </router-view>
  <div id="appRoot" class="z-50 relative" />
  <l-dialog-wrapper />
  <l-notification-wrapper />
</template>

<script setup lang="ts">
import { LDialogWrapper, LNotificationWrapper } from '@last/core-ui/paprika'
</script>
